<template>
    <div>
        <div class="row align-items-center mb-3">
            <div class="col-md-9">
                <label class="fs-6 mb-0" for="assigned_id">{{ $t('Patient ID') }}</label>
                <input placeholder="N/A" class="form-control form-control-sm" v-model="patient.assigned_id" name="assigned_id" id="assigned_id" />
            </div>
            <div class="col">
                <div class="form-check">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        v-model="isActiveValue"
                        name="is_active"
                        id="is_active"
                    >
                    <label class="form-check-label" for="is_active">{{ $t('Active') }}</label>
                </div>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6">
                <label class="fs-6 mb-0" for="first_name">{{ $t('First Name jjj') }}</label>
                <input placeholder="N/A" class="form-control form-control-sm" v-model="patient.first_name" name="first_name" id="first_name" />
            </div>
            <div class="col-md-6">
                <label class="fs-6 mb-0" for="last_name">{{ $t('Last Name') }}</label>
                <input placeholder="N/A" class="form-control form-control-sm" v-model="patient.last_name" name="last_name" id="last_name" />
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6">
                <label class="fs-6 mb-0" for="birth_date">{{ $t('Date Of Birth') }}</label>
                <AppDatepicker v-model="patient.birth_date"  format-model="YYYY-MM-DD" />
            </div>
            <div class="col-md-6">
                <label class="fs-6 mb-0" for="sex">{{ $t('Gender') }}</label>
                <select class="form-control" v-model="patient.sex" name="sex" id="sex">
                    <option value="m">{{ $t('Male') }}</option>
                    <option value="f">{{ $t('Female') }}</option>
                    <option value="o">{{ $t('Other') }}</option>
                </select>
            </div>
        </div>
        <div class="mb-3">
            <label class="fs-6 mb-0" for="therapy_start">{{ $t('Start On') }}</label>
            <AppDatepicker v-model="patient.therapy_start" />
        </div>
        <div class="row mb-3">
            <div class="col-md-6">
                <label class="fs-6 mb-0" for="therapy_start">Current Device Serial#</label>
                <input placeholder="N/A" class="form-control form-control-sm" v-model="patient.current_serial" name="current_serial" id="current_serial" />
            </div>
            <div class="col-md-6">
                <label class="fs-6 mb-0" for="therapy_start">Device PIN</label>
                <input placeholder="N/A" class="form-control form-control-sm" v-model="patient.device_pin" name="device_pin" id="device_pin" />
            </div>
        </div>
        <div class="mb-3">
            <label class="fs-6 mb-0" for="note">Note</label>
            <input placeholder="N/A" class="form-control form-control-sm" v-model="patient.note" name="note" id="note" />
        </div>
    </div>
</template>

<script setup>
import AppDatepicker from "../../../shared/AppDatepicker.vue";
import { computed } from "vue";

const props = defineProps({
    patient: Object,
});

const isActiveValue = computed({
    get: () => !!props.patient.is_rules_active,
    set: (v) => props.patient.is_rules_active = v,
});
</script>
